import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SfaProjectQualificationCriteriaSetLinkContainerModel } from "../../../../../../models/aggregates/sfa//project/SfaProjectQualificationCriteriaSetLinkContainer.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class SfaProjectQualificationCriteriaSetLinkService extends BaseApiTemplateService<SfaProjectQualificationCriteriaSetLinkContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.SFA_MODULE_PREFIX +
		"project-qualification-criteria-set-links";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"project-qualification-criteria-set-links";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.SFA_MODULE_PREFIX +
			"project-qualification-criteria-set-links";
		this.httpClient = http;
	}
}
